import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getAllLedgerAccountIdAndPartyName,
  getAllMasterBranchIdAndName,
  getAllMasterCurrencyIdAndName,
} from "../../../Redux/action/MasterAction";
import Cookies from "js-cookie";
import { adminMainUrl } from "../../../Config";
import { generateCode } from "../../../helper/autoGenId";
import axios from "axios";

const VoucherProcessingRemittanceClubbing = ({
  setPostPreData,
  postPreData,
  setActiveTab,
}) => {
  const token = Cookies.get("token");
  const user_id = Cookies.get("flexichain_user_id");
  const {
    MasterBranchName,
    MasterBranchNameError,

    loadingLedgerAccountIdAndPartyName,
    LedgerAccountIdAndPartyName,
    LedgerAccountIdAndPartyNameError,

    loadingMasterCurrencyIdAndName,
    MasterCurrencyIdAndName,
    MasterCurrencyIdAndNameError,
  } = useSelector((state) => state?.MasterReducer);

  const [remittanceClubbing, setRemittanceClubbing] = useState({
    remittance_id: "",
    remittance_date: "",
    branch: "",
    currency: "",
    exchange_rate: "",
    bank_charge: "",
    remittance_narration: "",

    // Invoices for Clubbing
    invoices_for_clubbing: [],

    total_invoices: 0,
    total_amount: 0,
    net_remittance: 0,
    base_amount: 0,
  });

  const [receiptVoucherSearch, setReceiptVoucherSearch] = useState({
    from_date: "",
    to_date: "",
    party_name: "",
    bill_no: "",
  });

  const [invoiceList, setInvoiceList] = useState([
    // demo data
    // {
    //   id: 1,
    //   party_name: "Global Shipping LLC",
    //   voucher_no: "INV-2025-001",
    //   voucher_date: "2025-01-05",
    //   original_amount: 15000,
    //   balance: 0,
    //   adjusted_amount: 0,
    //   effective_date: "",
    //   flag: "",
    // },
    // {
    //   id: 2,
    //   party_name: "Global Shipping LLC",
    //   voucher_no: "INV-2025-008",
    //   voucher_date: "2025-01-12",
    //   original: 8500,
    //   balance: 0,
    //   adjusted_amount: 0,
    //   effective_date: "",
    //   flag: "",
    // },
  ]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;
  const queryParams = new URLSearchParams(location.search);

  const calculateTotals = (selectedInvoices) => {
    const totalAdjusted = selectedInvoices.reduce((sum, inv) => {
      const amt = Number(inv.adjusted_amount) || 0;
      return sum + amt;
    }, 0);

    return {
      count: selectedInvoices.length,
      totalAdjustedUSD: totalAdjusted,
      // You can add exchange rate calculation here later
      // netRemittance: totalAdjusted - Number(remittanceClubbing.bank_charge || 0),
      // baseAmountINR: totalAdjusted * Number(remittanceClubbing.exchange_rate || 0),
    };
  };

  const clearAllInvoices = () => {
    setRemittanceClubbing((pre) => ({
      ...pre,
      invoices_for_clubbing: [],
    }));
  };

  const searchClubingInvoiceAPI = async (
    token,
    user_id,
    { from_date, to_date, bill_no, party_name }
  ) => {
    const config = {
      headers: {
        "auth-token": token,
        user_id: user_id,
        "Content-Type": "application/json",
      },
    };

    let apiUrl = `${adminMainUrl}/api/account/rcm/invoice`;

    const queryParams = [];
    if (from_date) queryParams.push(`from_date=${from_date}`);
    if (to_date) queryParams.push(`to_date=${to_date}`);
    if (party_name) queryParams.push(`party_name=${party_name}`);
    if (bill_no) queryParams.push(`bill_no=${bill_no}`);

    if (queryParams.length > 0) {
      apiUrl += `?${queryParams.join("&")}`;
    }

    try {
      const res = await axios.get(apiUrl, config);
      // console.log("API Response:", res.data);

      // Transform data to match table columns

      const transformedData = res.data.data.map((item) => ({
        id: item.id, // required by AntD Table
        party_name: item.ledger_account_name,
        party_name_id: item.ledger_account_id,
        voucher_no: item.voucher_id,
        voucher_date: item.date
          ? new Date(item.date).toLocaleDateString()
          : "-",
        original_amount: item.net_amount,
        balance: 0,
        currency_master: item.currency_master,
      }));

      setInvoiceList(transformedData);
    } catch (error) {
      console.error("Error fetching invoice :", error);
    }
  };

  const clubSearchHandler = () => {
    const { from_date, to_date, party_name, bill_no } = receiptVoucherSearch;
    if (!party_name) { toast.error("Please select a party name."); return; }
    searchClubingInvoiceAPI(token, user_id, {
      from_date,
      to_date,
      bill_no,
      party_name,
    });
  };

  const onSearchValueChange = (e) => {
    const { name, type, value, checked } = e.target;

    setReceiptVoucherSearch((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onValueChange = (e) => {
    const { name, type, value, checked } = e.target;

    let finalValue = value;

    if (type === "number") {
      const numericValue = Number(value);

      // Block negative values for fixed fields
      if (numericValue <= 0) {
        finalValue = ""; // or "" if you prefer empty
      } else {
        finalValue = numericValue;
      }
    }

    setRemittanceClubbing((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : finalValue,
    }));
  };

  // 1. Better version - update both lists when any field changes in table
  // const handleInvoiceFieldChange = (invoiceId, fieldName, value) => {
  //   setInvoiceList((prev) =>
  //     prev.map((inv) =>
  //       inv.id === invoiceId
  //         ? {
  //             ...inv,
  //             [fieldName]: value,
  //           }
  //         : inv
  //     )
  //   );

  //   setRemittanceClubbing((prev) => ({
  //     ...prev,
  //     invoices_for_clubbing: prev.invoices_for_clubbing.map((inv) =>
  //       inv.id === invoiceId ? { ...inv, [fieldName]: value } : inv
  //     ),
  //   }));

  // };

  // const handleInvoiceFieldChange = (invoiceId, fieldName, value) => {
  //   const numericValue =
  //     fieldName === "adjusted_amount" ? Number(value || 0) : value;

  //   setRemittanceClubbing((prev) => ({
  //     ...prev,
  //     invoices_for_clubbing: prev.invoices_for_clubbing.map((inv) =>
  //       inv.id === invoiceId ? { ...inv, [fieldName]: numericValue } : inv
  //     ),
  //   }));
  // };

  // 2. Improved toggle - when selecting, take current values from invoiceList

  const handleInvoiceFieldChange = (invoiceId, fieldName, value) => {
    setRemittanceClubbing((prev) => ({
      ...prev,
      invoices_for_clubbing: prev.invoices_for_clubbing.map((inv) => {
        if (inv.id !== invoiceId) return inv;

        const updatedAdjusted =
          fieldName === "adjusted_amount"
            ? Number(value || "")
            : Number(inv.adjusted_amount || "");

        const updated = {
          ...inv,
          [fieldName]:
            fieldName === "adjusted_amount" ? updatedAdjusted : value,
        };

        return {
          ...updated,
          balance: Number(updated.original_amount || 0) - updatedAdjusted,
        };
      }),
    }));
  };

  const toggleSelectInvoice = (invoice) => {
    const exists = remittanceClubbing.invoices_for_clubbing.some(
      (item) => item.id === invoice.id
    );

    if (exists) {
      // Remove
      setRemittanceClubbing((prev) => ({
        ...prev,
        invoices_for_clubbing: prev.invoices_for_clubbing.filter(
          (item) => item.id !== invoice.id
        ),
      }));
    } else {
      // Add current version of invoice
      setRemittanceClubbing((prev) => ({
        ...prev,
        invoices_for_clubbing: [...prev.invoices_for_clubbing, { ...invoice }],
      }));
    }
  };

  // 3. Select All - use current invoiceList values
  const selectAllInvoices = () => {
    setRemittanceClubbing((prev) => ({
      ...prev,
      invoices_for_clubbing: [...invoiceList],
    }));
  };

  const validateForm = () => {
    const errors = [];

    if (!remittanceClubbing.remittance_id?.trim()) {
      errors.push("Remittance ID is required");
    }

    if (!remittanceClubbing.remittance_date) {
      errors.push("Remittance Date is required");
    }

    if (!remittanceClubbing.branch) {
      errors.push("Branch is required");
    }

    if (!remittanceClubbing.currency) {
      errors.push("Currency is required");
    }

    if (
      !remittanceClubbing.exchange_rate ||
      isNaN(Number(remittanceClubbing.exchange_rate))
    ) {
      errors.push("Valid Exchange Rate is required");
    }

    const selected = remittanceClubbing.invoices_for_clubbing;

    if (selected.length === 0) {
      errors.push("Please select at least one invoice for clubbing");
    }
    // console.log("selected", selected);

    for (const inv of selected) {
      const adj = Number(inv.adjusted_amount);
      if (!inv.adjusted_amount || isNaN(adj) || adj <= 0) {
        errors.push(
          `Invoice ${inv.voucher_no}: Adjusted amount must be a positive number`
        );
      }
      if (!inv.effective_date) {
        errors.push(`Invoice ${inv?.id}: Effective date is required`);
      }
      // You can add balance check:
      // if (adj > Number(inv.balance || 0)) {
      //   errors.push(`Invoice ${inv.voucher_no}: Adjusted amount cannot exceed balance`);
      // }
    }

    if (errors.length > 0) {
      errors.forEach((err) => toast.error(err));
      return false;
    }

    return true;
  };

  const createReceiptVoucherApi = async () => {
    if (!validateForm()) return;

    try {
      setIsSubmitting(true);

      const response = await fetch(
        `${adminMainUrl}/api/account/remittance-clubbing`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": Cookies.get("token"),
            user_id: Cookies.get("flexichain_user_id"),
          },
          body: JSON.stringify(remittanceClubbing),
        }
      );

      const data = await response.json();

      if (response.ok) {
        toast.success(data?.msg || "Receipt remittance created successfully");
        setPostPreData({
          ...remittanceClubbing,
          // Add what posting needs
          remittance_id: remittanceClubbing.remittance_id,
          remittance_date: remittanceClubbing.remittance_date,
          invoice_amount: remittanceClubbing.total_amount,
          base_amount: remittanceClubbing.base_amount,
          remittance_amount: remittanceClubbing.net_remittance,
          exchange_variance: "0.00",
          remittance_status: "Draft",
          // You should get real invoice exchange rates from backend
        });
        setActiveTab("remittance_posting");
      } else {
        toast.error(data?.msg || "Failed to create remittance");
        console.error("Server error:", data);
      }
    } catch (error) {
      console.error("Network error:", error);
      toast.error("Something went wrong while saving");
    } finally {
      setIsSubmitting(false);
    }
  };

  const clearReceiptVoucherSearch = () => {
    setReceiptVoucherSearch({
      from_date: "",
      to_date: "",
      party_name: "",
      bill_no: "",
    });
  }

  const saveDataHandler = () => {
    // console.log("remittanceClubbing", remittanceClubbing);
  };

  useEffect(() => {
    const totalInvoice = remittanceClubbing.invoices_for_clubbing.length;
    const taxableAmount = remittanceClubbing.invoices_for_clubbing.reduce(
      (sum, row) => sum + Number(row.balance || 0),
      0
    );

    const netRemittance = remittanceClubbing.invoices_for_clubbing.reduce(
      (sum, row) => sum + Number(row.adjusted_amount || 0),
      0
    );

    setRemittanceClubbing((prev) => ({
      ...prev,
      total_invoices: totalInvoice,
      total_amount: taxableAmount.toFixed(2),
      net_remittance: netRemittance.toFixed(2),
    }));
  }, [remittanceClubbing.invoices_for_clubbing]);

  useEffect(() => {
    if (!remittanceClubbing.currency) return;

    const myCurrency = MasterCurrencyIdAndName.find(
      (item) => item.id == remittanceClubbing.currency
    );

    const newExchangeRate = myCurrency?.exchange_rate || 0;
    const baseAmount =
      Number(newExchangeRate) * Number(remittanceClubbing?.total_amount);

    setSelectedCurrency(myCurrency?.currency_code || "");

    setRemittanceClubbing((prev) => ({
      ...prev,
      exchange_rate: myCurrency?.exchange_rate || 0,
      base_amount: baseAmount?.toFixed(2) || 0,
    }));
  }, [
    remittanceClubbing.currency,
    remittanceClubbing.exchange_rate,
    remittanceClubbing.net_remittance,
    MasterCurrencyIdAndName,
  ]);

  useEffect(() => {
    if (token && user_id) {
      let remittance_id = generateCode();
      if (remittance_id) {
        setRemittanceClubbing((pre) => ({
          ...pre,
          ["remittance_id"]: remittance_id,
        }));
      }

      dispatch(getAllMasterBranchIdAndName(token, user_id));
      dispatch(getAllLedgerAccountIdAndPartyName(token, user_id));
      dispatch(getAllMasterCurrencyIdAndName(token, user_id));
    } else {
      toast.error("Please login to continue.");
      navigate(`/login?burl=${encodeURIComponent(q)}`);
    }
  }, [token, user_id, location.search]);

  // Summary - now dynamic
  const totals = calculateTotals(remittanceClubbing.invoices_for_clubbing);

  return (
    <>
      <style>
        {`
        .padding-pt-9 {
           padding: 9px;
          }
        `}
      </style>
      <div className="card p-4">
        <h5 className="fw-semibold mb-3">Remittance Clubbing Form</h5>
        <div className="row">
          {/* remittance_id */}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Remittance id<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="remittance_id"
              className="form-control bg-light"
              placeholder="Auto-generated"
              value={remittanceClubbing.remittance_id}
              disabled
            />
          </div>

          {/* remittance_date */}
          <div className="col-md-4 mb-4">
            <label className="form-label fw-medium">Remittance Date</label>
            <input
              type="date"
              name="remittance_date"
              className="form-control bg-light"
              placeholder="Enter to date"
              onChange={onValueChange}
              value={remittanceClubbing.remittance_date}
            />
          </div>

          {/* branch */}
          <div className="col-md-4 mb-4">
            <label className="form-label fw-medium">Branch</label>
            <select
              name="branch"
              className="form-select bg-light padding-pt-9"
              value={remittanceClubbing.branch}
              onChange={onValueChange}
            >
              <option value="">Select Branch</option>
              {MasterBranchName?.map((item, i) => (
                <option value={item.id}>{item.name}</option>
              ))}
            </select>
          </div>

          {/* currency */}
          <div className="col-md-4 mb-4">
            <label className="form-label fw-medium">Currency</label>
            <select
              name="currency"
              className="form-select bg-light padding-pt-9"
              value={remittanceClubbing.currency}
              onChange={onValueChange}
            >
              <option value="">Select Currency </option>
              {MasterCurrencyIdAndName.map((item, i) => (
                <option value={item.id}>{item.currency_name}</option>
              ))}
            </select>
          </div>

          {/* exchange_rate */}
          <div className="col-md-4 mb-4">
            <label className="form-label fw-medium">Exchange Rate</label>
            <input
              type="number"
              name="exchange_rate"
              className="form-control bg-light "
              value={remittanceClubbing.exchange_rate}
              onChange={onValueChange}
              placeholder="280.00"
            />
          </div>

          {/* bank_charge */}
          <div className="col-md-4 mb-4">
            <label className="form-label fw-medium">Bank Charge</label>
            <input
              type="number"
              name="bank_charge"
              className="form-control bg-light"
              value={remittanceClubbing.bank_charge}
              onChange={onValueChange}
              placeholder="0.00"
            />
          </div>

          {/* remittance_narration */}
          <div className="col-12 mb-4">
            <label className="form-label fw-medium">Remittance Narration</label>
            <input
              type="text"
              name="remittance_narration"
              className="form-control bg-light"
              value={remittanceClubbing.remittance_narration}
              onChange={onValueChange}
              placeholder="Remittance Narration"
            />
          </div>
        </div>
      </div>

      {/* search invoice for clubbing */}
      <div className="card p-4 mt-4">
        <h5 className="fw-semibold">Search Invoices for Clubbing</h5>
        <div className="row">
          {/* from_date */}
          <div className="col-md-4 mb-4">
            <label className="form-label fw-medium">From Date</label>
            <input
              type="date"
              name="from_date"
              className="form-control bg-light"
              placeholder="Enter from date"
              onChange={onSearchValueChange}
              value={receiptVoucherSearch.from_date}
            />
          </div>

          {/* to_date */}
          <div className="col-md-4 mb-4">
            <label className="form-label fw-medium">To Date</label>
            <input
              type="date"
              name="to_date"
              className="form-control bg-light"
              placeholder="Enter to date"
              onChange={onSearchValueChange}
              value={receiptVoucherSearch.to_date}
            />
          </div>

          {/* part name */}
          <div className="col-md-4 mb-4">
            <label className="form-label fw-medium">Party Name</label>

            <select
              name="party_name"
              className="form-select bg-light padding-pt-9"
              value={receiptVoucherSearch.party_name}
              onChange={onSearchValueChange}
            >
              <option value="">Select Party Name </option>
              {LedgerAccountIdAndPartyName.map((item, i) => (
                <option value={item.id}>{item.ledger_party_name}</option>
              ))}
            </select>
          </div>

          {/* bill no */}
          <div className="col-md-4 mb-4">
            <label className="form-label fw-medium">Bill No</label>
            <input
              type="text"
              name="bill_no"
              className="form-control bg-light"
              value={receiptVoucherSearch.bill_no}
              onChange={onSearchValueChange}
              placeholder="Bill No"
            />
          </div>

          {/* ACTION BUTTONS */}
          <div className="d-flex flex-wrap gap-2 mt-3">
            <button
              onClick={() => clubSearchHandler()}
              className="btn btn-primary px-4"
            >
              {/* <i className="fas fa-save me-1"></i>  */}
              Search
            </button>

            <button
              onClick={() => clearReceiptVoucherSearch()}
              className="btn btn-light border px-4"
            >
              <i className="fas fa-undo me-1"></i> Clear
            </button>
          </div>
        </div>
      </div>

      {/* select invoice for clubbing */}
      <div className="card p-4 mt-4">
        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-semibold">Select Invoices for Clubbing</h5>

          <div className="d-flex gap-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={
                  remittanceClubbing.invoices_for_clubbing.length ===
                  invoiceList.length
                }
                onChange={selectAllInvoices}
              />
              <label className="form-check-label fw-medium">Select All</label>
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={remittanceClubbing.invoices_for_clubbing.length === 0}
                onChange={clearAllInvoices}
              />
              <label className="form-check-label fw-medium">
                Clear Selection
              </label>
            </div>
          </div>
        </div>

        {/* TABLE */}
        <div className="table-responsive">
          <table className="table align-middle">
            <thead>
              <tr>
                <th>Select</th>
                <th>Party Name</th>
                <th>Voucher No</th>
                <th>Voucher Date</th>
                <th>Original Amount</th>
                <th>Balance</th>
                <th>Adjusted Amount</th>
                <th>Effective Date</th>
                {/* <th>Flag</th> */}
              </tr>
            </thead>

            <tbody>
              {invoiceList.map((inv) => (
                <tr key={inv.id}>
                  <td>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={remittanceClubbing.invoices_for_clubbing.some(
                        (item) => item.id === inv.id,
                      )}
                      onChange={() => toggleSelectInvoice(inv)}
                    />
                  </td>

                  <td>{inv.party_name}</td>
                  <td>{inv.voucher_no}</td>
                  <td>{inv.voucher_date}</td>
                  <td>${inv.original_amount}</td>
                  {/* <td>${inv.balance}</td> */}
                  <td>
                    $
                    {remittanceClubbing.invoices_for_clubbing.find(
                      (i) => i.id === inv.id,
                    )?.balance ?? inv.original_amount}
                  </td>

                  {/* Editable fields - now properly controlled */}
                  <td>
                    <input
                      type="number"
                      className="form-control bg-light"
                      placeholder="0.00"
                      value={
                        remittanceClubbing.invoices_for_clubbing.find(
                          (i) => i.id === inv.id,
                        )?.adjusted_amount ?? ""
                      }
                      onChange={(e) =>
                        handleInvoiceFieldChange(
                          inv.id,
                          "adjusted_amount",
                          e.target.value,
                        )
                      }
                      disabled={
                        !remittanceClubbing.invoices_for_clubbing.some(
                          (i) => i.id === inv.id,
                        )
                      }
                    />
                  </td>

                  <td>
                    <input
                      type="date"
                      className="form-control bg-light"
                      value={
                        remittanceClubbing.invoices_for_clubbing.find(
                          (i) => i.id === inv.id,
                        )?.effective_date ?? ""
                      }
                      onChange={(e) =>
                        handleInvoiceFieldChange(
                          inv.id,
                          "effective_date",
                          e.target.value,
                        )
                      }
                      disabled={
                        !remittanceClubbing.invoices_for_clubbing.some(
                          (i) => i.id === inv.id,
                        )
                      }
                    />
                  </td>

                  {/* <td>
                    <select
                      className="form-select bg-light"
                      value={
                        remittanceClubbing.invoices_for_clubbing.find(
                          (i) => i.id === inv.id
                        )?.flag ?? ""
                      }
                      onChange={(e) =>
                        handleInvoiceFieldChange(inv.id, "flag", e.target.value)
                      }
                      disabled={
                        !remittanceClubbing.invoices_for_clubbing.some(
                          (i) => i.id === inv.id
                        )
                      }
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* remittance summary */}

      <div className="card p-4 mt-4">
        <h5 className="fw-semibold mb-4">Remittance Summary</h5>

        <div className="row g-3">
          {/* Total Invoices */}
          <div className="col-md-3">
            <label className="fw-medium text-muted">Total Invoices</label>
            <div className="px-3 py-2 bg-light rounded-3 mt-1 fw-semibold">
              {remittanceClubbing?.total_invoices || 0}
            </div>
          </div>

          {/* Total Amount (USD) */}
          <div className="col-md-3">
            <label className="fw-medium text-muted">Total Amount (USD)</label>
            <div className="px-3 py-2 bg-light bg-opacity-10 rounded-3 mt-1 fw-semibold">
              $ {remittanceClubbing?.total_amount || 0}
            </div>
          </div>

          {/* adjustment Amount */}
          <div className="col-md-3">
            <label className="fw-medium text-muted">Adjusted Amount</label>
            <div className="px-3 py-2 bg-light bg-opacity-10  rounded-3 mt-1 fw-semibold">
              $ {remittanceClubbing?.net_remittance || 0}
            </div>
          </div>

          {/* Base Amount (INR) */}
          <div className="col-md-3">
            <label className="fw-medium text-muted">
              Base Amount ( {selectedCurrency} )
            </label>
            <div className="px-3 py-2 bg-light bg-opacity-10  rounded-3 mt-1 fw-semibold">
              ₹ {remittanceClubbing?.base_amount || 0}
            </div>
          </div>
        </div>

        <hr className="my-4" />

        {/* BUTTONS */}
        <div className="col-md-4 mb-4">
          <label className="form-label fw-medium">Report Type</label>
          <select className="form-select bg-light padding-pt-9">
            <option value="">Select Type </option>
            <option value="clubbing">Clubbing</option>
          </select>
        </div>

        <div className="d-flex gap-2 flex-wrap">
          <button
            onClick={() => createReceiptVoucherApi()}
            className="btn btn-primary px-4"
          >
            <i className="fa-regular fa-floppy-disk me-1"></i> Club Invoice
          </button>

          {/* <button className="btn btn-primary px-4">
            <i className="fa-solid fa-paper-plane me-1"></i> Post
          </button> */}

          <button className="btn-light border px-4">
            <i className="fa-solid fa-xmark me-1"></i> Cancel
          </button>
        </div>
      </div>
    </>
  );
};

export default VoucherProcessingRemittanceClubbing;
